import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, CartService, ContextService, SigninService, ArticlesService } from '../../shared';
import { environment } from '../../../environments/environment';
import { User, Panier, LignePanier, Etablissement } from '../../shared';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as html2c from 'html2canvas';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  currentUser: User;
  isAuthed: boolean;
  context: string;
  context_url: string;
  imgfolder_url: string;

  panier: any;
  loadedPanier: Panier;
  articles: Array<LignePanier>;
  saved: boolean = false;
  nombre_articles: number= 0;
  quantite_change: number;
  total: number = 0;

  today = Date.now();
  etablissement: Etablissement;

  //loading: boolean = false;
  check: boolean;
  status: boolean;
  start_validation: boolean;
  errorMessage: string = "";

  savedTemplate: TemplateRef<any>;
  modalRef: BsModalRef;
  loading: boolean = true;
  hasreload: boolean = false;

 todayDate = new Date().toLocaleDateString();


  constructor(
    private userService: UserService,
    private cartService: CartService,
    private contextService: ContextService,
    private signinService: SigninService,
    private articleService: ArticlesService,
    private modalService: BsModalService,
    private router: Router,
  ) { 
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    window.scrollTo(0, 0);
    this.cartService.cartevent.subscribe(
      (data: any) => {
        if(data=='cartchange') {
         this.ngOnInit();
         if(!this.hasreload){
           this.hasreload=true;
           this.ngOnInit();
         }
       }
      });



  }

  ngOnInit() {
    this.isAuthed = this.userService.isAuthenticatedSubject.getValue();
    this.context = this.contextService.getContext();
    this.context_url = ( this.context == 'B2C' ) ? '/familles' : '';
    this.imgfolder_url = environment.imgfolder_url;
    this.getCart()
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        // this.getCart()
        if(userData.uai){
          this.signinService.checkUAI(userData.uai[0])
            .subscribe(
              (data) => {
                this.etablissement = data;

              }
            );
        }
      }
    );

  

     sessionStorage.setItem('preuveachat_kne', JSON.stringify({
        preuvesAchat : {},
        preuvesAchatPapier : false

     }));
       

   
  }

  getCart(){
    // console.log(this.isAuthed)
    this.total = 0;
     if(this.isAuthed){
        this.cartService.getUserCart().subscribe(
          data => {
            this.panier = data;
            console.log(data)
            this.loadedPanier  = data;
            this.processPanier()
            this.loading=false
          }
         );
    }else{
      this.panier = this.cartService.getLocalCart();
      this.processPanier();
      this.loading=false
     
    }
    

    
  }

  processPanier(){
   
    if(this.panier != null){
      //console.log(this.panier)
      this.articles=[];
      this.total=0;
      this.nombre_articles=0;
      if(this.panier.lignePanier){
        this.articles = this.panier.lignePanier;
        this.nombre_articles = this.articles.length;
        this.total = this.panier.montantTotal;
        // this.articles.forEach(function (e){
        //   this.total += e.quantite * e.prixUnitaireTTC;
        //   let temp: any;
        //   this.articleService.get(e.codeEAN,this.context ).subscribe(
        //     data => temp = data,
        //     error => console.log(error),
        //     () => {
        //       if(temp.article.dateDisponibiliteReelle != null){
        //         e.dateDisponibilite = '';
        //       } else {
        //         e.dateDisponibilite = temp.article.dateDisponibiliteTheorique;
        //       }
        //     }
        //   );
        // }, this);
        // this.total += this.panier.montantFraisDePort;
        this.panier.montantTotal = this.total;

      }
      if(this.isAuthed){
        this.total=this.loadedPanier.montantTotal;
        // this.panier.montantTotal = this.loadedPanier.montantTotal;

     
      }
   

    }

  }

  updateLine(item: any){
     if(item.quantite < item.quantiteMinimaleAchat){
      item.quantite = item.quantiteMinimaleAchat;
    }
    if(this.isAuthed){
      let line=this.processItem(item);
      this.cartService.putLineUpdate(line).subscribe(
          data => {
             this.getCart();
          }
         );
    }else{
      this.cartService.updateLineFromLocalCart(item);
       this.getCart();
    }  
   

  }

  processItem(item){
      let line: {id: string, idOffreCommerciale: string, indicateurAdoption: string,  quantite: string,  idPaysLPC: string} = {
          id:item.id,
          idOffreCommerciale:item.idOffreCommerciale,
          indicateurAdoption:item.indicateurAdoption,
          quantite:item.quantite,
          idPaysLPC:item.idPaysLPC,
      };
     
     
      return line;
  }




  trackByIndex(index: number, value: LignePanier): number{
    return index;
  }

  removeFromCart(item: any){
     if(this.isAuthed){
      
      this.cartService.deleteLine(item.id).subscribe(
          data => {
             this.cartService.cartevent.emit('cartchange');
             this.getCart();
          }
         );

    }else{
      this.hasreload=false;
      this.cartService.deleteLineFromLocalCart(item);
     
      this.getCart();
    }
  }

  onSubmit(){
    this.errorMessage = "";
    if(!this.check){
      this.errorMessage = "Merci de cocher la case relative aux configurations minimales requises";
      return;
    }

    // if(!this.saved && this.isAuthed){
    //   this.errorMessage = 'Veuillez enregistrer votre panier avant de continuer.';
    //   return;
    // }
    //this.saveCart();

    if(!this.isAuthed){
      
      if(this.context == 'B2B'){
        this.router.navigate(['/identification']);
      } else {
        this.router.navigate(['/familles/identification']);
      } 
    } else {
      /// Vérification si preuve d'achat
      let count = this.countAdoptions(this.articles);
      if(count > 0){
        this.start_validation = true;
        
        if(this.context == 'B2B'){
          //// si b2b -> redirection justificatifs
          this.router.navigate(['/justificatifs']);
        } else {
           //// si b2c -> redirection nouvelle page justificatifs
          this.router.navigate(['/familles/justificatifs']);
        }
      } else {
        if(this.context == 'B2B'){
          this.router.navigate(['/adresses']);
        } else {
          this.router.navigate(['/familles/adresses']);
        }
      }
    }

  }

  dateFormat(date: string){
    if(new Date(date.replace(/-/g, "/")) < new Date() || new Date(date.replace(/-/g, "/")).toLocaleDateString() == 'Invalid Date') return '';
    return new Date(date.replace(/-/g, "/")).toLocaleDateString();
  }


  countAdoptions(articles: Array<LignePanier>){
    let count: number = articles.filter( a => a.indicateurAdoption == true ).length;
    return count;
  }

  saveCart(){
    this.errorMessage = '';
    if(!this.isAuthed){
      return;
    }
    //this.loading = true;

    this.deleteCurrentUserCart();
    this.saved = true;
    // this.savedTemplate = template;
    // this.openModal(this.savedTemplate);
      
    //this.loading = false;

  }

  deleteCurrentUserCart(){
    let cart: Panier;
    let lignes: Array<LignePanier>;

    this.cartService.getUserCart().subscribe(
      data => {
        cart = data;
        // console.log(data);
        if(data.lignePanier){
          lignes = data.lignePanier;
          lignes.forEach( function(l) {
            this.cartService.deleteLine(l.id).subscribe();
          }, this);
        }
      },
      error => {
        console.log(error);
      },
      () => {
        this.postNewLines();
      }
    );

  }

  postNewLines(){
    let cart: Panier = this.cartService.getLocalCart();
    let lignes: Array<LignePanier> = cart.lignePanier;

    lignes.forEach( function(l){
      let ligne = {
        idOffreCommerciale: l.idOffreCommerciale,
        indicateurAdoption: l.indicateurAdoption,
        quantite: l.quantite,
        idPaysLPC: this.currentUser.idPaysLPC
      }
      let temp: Panier;
      this.cartService.postLineValidateSave(ligne).subscribe(
        data => temp = data,
        error => console.log(error),
        () => {
          if(temp.lignePanier){
            this.cartService.setLocalCart(temp);
            this.panier = temp;
          }
        }
      );
    }, this);

  }



  genererDevis(){
    this.errorMessage = '';
    if(!this.isAuthed){
      this.errorMessage = 'Veuillez vous connecter pour pouvoir générer un devis.';
      return;
    }

    let el = document.getElementById('devis');
    const PAGE_HEIGHT = 700*3;                                                                                                                                                            
    const PAGE_WIDTH = 520*3;   
    const content = [];

    const splitImage = (img, content) => () => {

        const canvas = document.createElement('canvas');
        const ctx    = canvas.getContext('2d');
        const printHeight = img.height * PAGE_WIDTH / img.width;

        canvas.width = PAGE_WIDTH;

        for (let pages = 0; printHeight > pages * PAGE_HEIGHT; pages++) {
            /* Don't use full height for the last image */
            canvas.height = Math.min(PAGE_HEIGHT, printHeight - pages * PAGE_HEIGHT);
            ctx.drawImage(img, 0, -pages * PAGE_HEIGHT, canvas.width, printHeight);
            content.push({ image: canvas.toDataURL(), margin: [0, 5], width: PAGE_WIDTH/3 });
        }

        //callback();
        //console.log('go multi')
        this.next(content);
    };

    html2c(el).then( canvas => {
      var img = canvas.toDataURL();
      const { width, height } = this.getPngDimensions(img);
      const printHeight = height * PAGE_WIDTH / width;

      if (printHeight > PAGE_HEIGHT) {

        const im = new Image();
        im.onload = splitImage(im, content);
        im.src = img;
        return;
      }else{

        content.push({ image: img, margin: [0, 5], width: PAGE_WIDTH/3  });
        this.next(content);

      }

      
    });

  }

  getPngDimensions (base64) {
  /*  console.log(base64);
    console.log(base64.slice(22,70))
    console.log(atob(base64.slice(22,70)))*/
      const header = atob(base64.slice(22, 70)).slice(16, 24);
      // console.log(header)
      let arr = [];
      header.split('').forEach(c => {
        arr.push(c.charCodeAt(0));
      });
      const uint8 = Uint8Array.from( arr );
      const dataView = new DataView(uint8.buffer);

      return {
          width: dataView.getInt32(0),
          height: dataView.getInt32(4)
          // width: 0,
          // height: 0
      };
  }

  next (content) {
 
    pdfMake.createPdf({ content }).download('devis.pdf');
  }

  openModal(template: TemplateRef<any>){
    this.modalRef = this.modalService.show(template);
  }

}


// WEBPACK FOOTER //
// ./src/app/user/_cart/cart.component.ts